<template>
<transition name="fade" appear>
  <div class="tags-container">
    <ul class="tags">
      <MVMTag
        v-for="name in tags"
        :key="name"
        :name="name"
        :active="getStatus(name)"
        @toggle="toggle"
      />
    </ul>
  </div>
</transition>
</template>

<script>
import MVMTag from './MVMTag'
import { TweenMax } from 'gsap'

export default {
  name: 'MVMTags',
  components: {
    MVMTag
  },

  data () {
    return {
      selectedTags: ['all'],
      tags: [
        'all',
        'illustration',
        'design',
        'art',
        'pattern',
        'editorial',
        'advertising',
        'branding',
        'commercial',
        'portrait',
        'music',
        'culture',
        'fashion'
      ]
    }
  },

  props: {
    msg: String
  },

  mounted () {
    let tags = document.querySelectorAll('ul.tags li')
    TweenMax.set(tags, { autoAlpha: 0 })
    TweenMax.staggerTo(tags, 1, { autoAlpha: 1, delay: 0.45 }, 0.05)
  },

  methods: {
    toggle (data) {
      if (data.name === 'all') {
        // reset all
        this.selectedTags = ['all']
      } else {
        this.removeAll()
        if (data.active) {
          this.selectedTags = [
            data.name,
            ...this.selectedTags
          ]
        } else {
          let idx = this.selectedTags.indexOf(data.name)
          this.selectedTags = [
            ...this.selectedTags.slice(0, idx),
            ...this.selectedTags.slice(idx + 1)
          ]
        }
        if (!this.selectedTags.length) {
          this.selectedTags = ['all']
        }
      }
      this.$emit('change', this.selectedTags)
    },

    getStatus (name) {
      return this.selectedTags.indexOf(name) > -1
    },

    removeAll () {
      let idx = this.selectedTags.indexOf('all')
      if (idx > -1) {
        this.selectedTags = [
          ...this.selectedTags.slice(0, idx),
          ...this.selectedTags.slice(idx + 1)
        ]
      }
    }
  }
}
</script>
